/**
 * Wiederverwendbarer Abschnitts-Header.
 * Props: eyebrow, title, text (optional), centered (bool)
 */
export default function SectionHeader({ eyebrow, title, text, centered = false }) {
  return (
    <div className={`mb-10 ${centered ? "text-center" : ""}`}>
      {eyebrow && (
        <p className="text-accent font-bold uppercase tracking-widest text-xs mb-3">
          {eyebrow}
        </p>
      )}
      <h2 className="text-3xl md:text-5xl font-extrabold uppercase leading-tight">{title}</h2>
      {text && (
        <p className={`mt-4 text-dark/70 text-lg leading-relaxed ${centered ? "mx-auto max-w-2xl" : "max-w-2xl"}`}>
          {text}
        </p>
      )}
    </div>
  );
}
